import React, { useState } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import PushFcmTopicExplorer from './push-fcm-topic-explorer';
import PushNoticationAutomated from './push-notification-automated';
import PushNotificationManual from './push-notification-manual';
import PushNoticationSend from './push-notification-send';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { Box, Button } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import { drawerWidth } from '../../../constants';
import { useUserAuth } from '../../../contexts/auth';
import SceneHeader from '../../common/scene/scene-header';
import SceneTabs from '../../common/scene/scene-tabs';
import SceneTopBar from '../../common/scene/scene-top-bar';
import SceneContent from '../../common/scene/scene-content';
import SceneBottomBar from '../../common/scene/scene-bottom-bar';
import { ROLES, SxStyle } from '../../../types';

const styles: SxStyle = {
  headerContainer: (theme) => ({
    [theme.breakpoints.up('sm')]: {
      marginLeft: `${drawerWidth}px`,
    },
    paddingTop: '80px',
    paddingLeft: '24px',
    paddingRight: '24px',
  }),
};

enum TABS {
  SEND,
  AUTOMATED,
  MANUAL,
  FCM,
}

export default function PushNotification() {
  const [selectedTab, setSelectedTab] = useState(TABS.SEND);
  const { strings } = useStringsContext();
  const [, page] = location.pathname.split('/');
  const params = useParams<{ abbrv: string }>();
  const { isSuperAdmin, hasTeamRole } = useUserAuth();
  const isReadOnly = !isSuperAdmin && hasTeamRole(params.abbrv, ROLES.VIEWER);
  const breadCrumps = useBreadcrumbs();

  return (
    <>
      <SceneTopBar title={strings.appBar.pushNotificationLog} breadCrumps={breadCrumps} />
      <Box sx={styles.headerContainer}>
        <SceneHeader title={strings.pushNotifications.title}>
          <Button
            variant="contained"
            component={Link}
            to={`/${page}/${params.abbrv}/segments`}
            disabled={isReadOnly}
          >
            {strings.pushNotifications.pushNotificationSegments}
          </Button>
          <Button
            variant="contained"
            startIcon={<SettingsIcon />}
            component={Link}
            to={`/${page}/${params.abbrv}/settings`}
            disabled={isReadOnly}
          >
            {strings.pushNotifications.pushNotificationSettings}
          </Button>
        </SceneHeader>
      </Box>
      <SceneTabs
        inContent
        tabs={
          [
            strings.pushNotifications.tabSendPush,
            strings.pushNotifications.tabAutomatedPush,
            strings.pushNotifications.tabManualPush,
            isSuperAdmin ? strings.pushNotifications.tabExploreFCM : null,
          ].filter(Boolean) as string[]
        }
        selectedTab={selectedTab}
        onSelectedTab={setSelectedTab}
      />
      <SceneContent withTabsAbove>
        {selectedTab === TABS.SEND && <PushNoticationSend />}
        {selectedTab === TABS.AUTOMATED && <PushNoticationAutomated />}
        {selectedTab === TABS.MANUAL && <PushNotificationManual />}
        {selectedTab === TABS.FCM && <PushFcmTopicExplorer />}
      </SceneContent>
      <SceneBottomBar />
    </>
  );
}
